import { computed, makeAutoObservable } from 'mobx';
import { createGuard } from 'src_common/common/createGuard';

import * as t from 'io-ts';
import { getToken } from './getToken';
import { Value } from 'src_common/common/mobx-utils/Value';

const JwtDataIO = t.type({
    sub: t.string,
    nbf: t.number,
    sc: t.string,
});

export type JwtDataType = t.TypeOf<typeof JwtDataIO>;

const isJwtData = createGuard(JwtDataIO);

export class UserLoginState {
    private readonly cookie: Value<string | null>;

    constructor() {
        this.cookie = new Value(getToken(), (setValue) => {
            const timer = setInterval(() => {
                setValue(getToken());
            }, 1000);

            return (): void => {
                clearInterval(timer);
            };
        });
        makeAutoObservable(this);
    }

    private decode(currentJwt: string): JwtDataType | null {
        const chunks = currentJwt.split('.');

        if (chunks.length !== 3) {
            console.error('decodedJwtData1: three parts were expected');
            return null;
        }

        const jwtData = chunks[1];

        if (jwtData === undefined) {
            console.error('decodedJwtData2: second part missing');
            return null;
        }

        try {
            const data = JSON.parse(atob(jwtData));

            if (isJwtData(data)) {
                return data;
            }
        } catch (error) {
            console.error(error);
        }
        return null;
    }

    @computed get userId(): number | null {
        const cookieEncoded = this.cookie.getValue();
        if (cookieEncoded !== null) {
            const decodedData = this.decode(cookieEncoded);

            if (decodedData === null) {
                return null;
            }

            if (decodedData.sub === '') {
                return null;
            }

            const subNum = parseInt(decodedData.sub, 10);

            if (isNaN(subNum)) {
                console.error('userId NaN');
                return null;
            }

            return subNum;
        }

        return null;
    }
}
